export default __webpack_public_path__ + "static/mhl-cover-73d3d302b5e6be8cdf4a3867cd3388e9.jpg";